import React from "react";
import { Popover } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import UptimeTimeline from "./UptimeTimeline";
import ApdexTimeline from "./ApdexTimeline";
import PopOverItem from "./PopOverItem";
import { history } from "../routers/AppRouter";

class Check extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: false,
      moreVisible: false,
      detail: false,
      visible: false
    };
  }

  hide = () => {
    this.setState({
      visible: false
    });
  };

  handleVisibleChange = visible => {
    this.setState({ visible });
  };

  onEdit = () => {
    this.props.onEdit(this.props.id);
  };

  onRemove = () => {
    this.props.onRemove({ id: this.props.id });
  };

  onShare = () => {
    this.props.onShare(this.props.token);
  };

  more = () => {
    history.push(`/monitor/${this.props.id}`);
  };

  render() {
    const PopOverData = [
      {
        link: "",
        func: this.onEdit,
        title: "Edit",
        primary: false
      },
      {
        link: "",
        func: this.onShare,
        title: "Share",
        primary: false
      },
      {
        link: "",
        func: this.onRemove,
        title: "Remove",
        primary: false,
        disable: this.props.is_protected
      }
    ];
    const isActive = this.props.activeCheckId === this.props.id.toString();

    return (
      <div className="check">
        <div
          className={`check-left ${isActive && "active"} ${
            this.props.data && this.props.data.is_down && this.props.is_enabled
              ? "is-down"
              : ""
          } ${!this.props.is_enabled ? "disable" : ""}`}
        >
          <div className="check__topside">
            <div className="check__topside__left" onClick={this.more}>
              <div className="check__url">
                <div className="check__url__type">
                  <h6 className="protocol-type">{this.props.protocol_type}</h6>
                  {formatProtocol(this.props.protocol_type, this.props.alias)}
                </div>
                <p>
                  {this.props.alias
                    ? this.props.alias
                    : this.props.protocol_type === "HTTP(S)"
                    ? `${this.props.url}`
                    : `${this.props.protocol_type === "DNS" ? "" : "//"}${
                        this.props.host
                      }`}
                </p>
              </div>
              <div className="check__uptime">
                <p>
                  {this.props.data
                    ? this.props.is_enabled
                      ? this.props.protocol_type === "HTTP(S)"
                        ? this.props.data.last_status_code
                        : this.props.data.last_status
                      : "Disable"
                    : ""}
                </p>
              </div>
            </div>
            <Popover
              content={<Content data={PopOverData} onClose={this.hide} />}
              trigger="click"
              placement="topRight"
              visible={this.state.visible}
              onVisibleChange={this.handleVisibleChange}
            >
              <MoreOutlined />
            </Popover>
          </div>
          <div className="timelines" onClick={this.more}>
            <div className="timeline">
              <div className="label">uptime</div>
              <div className="chart">
                <UptimeTimeline
                  uptime={
                    this.props.data ? this.props.data.uptime_percent : null
                  }
                  downtimes={this.props.data ? this.props.data.downtimes : []}
                  lastCheckAt={
                    this.props.data ? this.props.data.last_check_at : null
                  }
                  firstCheckAt={
                    this.props.data ? this.props.data.first_check_at : null
                  }
                />
              </div>
            </div>
            <div className="timeline">
              <div className="label">apdex</div>
              <div className="chart">
                <ApdexTimeline
                  datas={
                    this.props.data && this.props.data.last_day_hourly_metrics
                      ? this.props.data.last_day_hourly_metrics.apdex_percents
                      : []
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const Content = props => (
  <div className="user-popup">
    {props.data.map((el, index) => (
      <PopOverItem
        link={el.link}
        title={el.title}
        func={el.func}
        key={el.title}
        onClick={props.onClose}
        primary={el.primary}
        disable={el.disable}
      />
    ))}
  </div>
);

const formatProtocol = (proto, alias) => {
  return proto === "HTTP(S)" && !!alias ? (
    <p>http(s):</p>
  ) : proto === "TCP" ? (
    <p>tcp:</p>
  ) : proto === "ICMP" ? (
    <p>icmp:</p>
  ) : proto === "DNS" ? (
    <p>dns:</p>
  ) : (
    undefined
  );
};

export default Check;
